<template>
    <div class="file-wrapper-argument">
        <span v-if="list?.length === 1" class="file-wrapper-argument__label">
            {{ $t('fileWrapperMultiView.argumentByApplicant', {
                mrdt: currentSelectArgument.mrdt,
            }) }}
        </span>
        <Dropdown
            v-else
            class="file-wrapper-argument__dropdown"
            trigger="click"
            @visible-change="(val) => isShowDropDown = val"
            @command="onSelect"
        >
            <div class="file-wrapper-argument__dropdown__btn">
                <span>{{ $t('fileWrapperMultiView.argumentByApplicant', {
                    mrdt: currentSelectArgument.mrdt,
                }) }}</span>
                <PtIcon
                    :icon="isShowDropDown ? 'SolidDropdownClose' : 'SolidDropdownOpen'"
                />
            </div>
            <template #dropdown>
                <DropdownMenu>
                    <DropdownItem
                        v-for="item in list"
                        :key="item.mrdt"
                        :command="item"
                    >
                        {{ $t('fileWrapperMultiView.argumentByApplicant', {
                            mrdt: item.mrdt,
                        }) }}
                    </DropdownItem>
                </DropdownMenu>
            </template>
        </Dropdown>
        <FileWrapperMultiViewPdf
            class="file-wrapper-argument__main"
            :pdf="currentSelectArgument.pdf"
            :nodataTips="$t('fileWrapperMultiView.argumentDisabled')"
        />
    </div>
</template>

<script setup lang="ts">
import { ref, defineProps, defineEmits, watch } from 'vue';
import _ from 'lodash';
import FileWrapperMultiViewPdf from './FileWrapperMultiViewPdf.vue';
import { Dropdown, DropdownMenu, DropdownItem } from 'element-ui';
import { Icon as PtIcon } from 'patsnap-biz';
import '@patsnap-ui/icon/assets/solid/DropdownClose.svg';
import '@patsnap-ui/icon/assets/solid/DropdownOpen.svg';

const isShowDropDown = ref(false);

const props = defineProps({
    list: {
        type: Array,
        default: () => [],
    },
    mrdt: {
        type: String,
        default: '',
    },
});

const emits = defineEmits(['onChange']);

const currentSelectArgument = ref();

const onSelect = (item) => {
    currentSelectArgument.value = item;
};

watch(currentSelectArgument, () => {
    const mrdt = _.get(currentSelectArgument.value, 'mrdt');
    emits('onChange', mrdt);
}, { immediate: true });

// 获取默认选中
watch(() => props.mrdt, (val) => {
    const item = _.find(props.list, { mrdt: val });
    if (item) {
        currentSelectArgument.value = item;
    } else {
        currentSelectArgument.value = _.head(props.list);
    }
}, { immediate: true });

</script>

<style lang="scss">
.file-wrapper-argument {
    padding: 4px 16px 8px 16px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    .file-wrapper-argument__label {
        line-height: 24px;
        font-weight: 600;
        padding: 2px 4px;
    }

    .file-wrapper-argument__dropdown {
        .file-wrapper-argument__dropdown__btn {
            line-height: 24px;
            border-radius: 4px;
            color: $text-primary;
            font-weight: 600;
            padding: 2px 4px;
            cursor: pointer;
            outline: none;
            display: flex;
            align-items: center;

            &:hover {
                background-color: $bg-dark;
            }
        }
    }

    .file-wrapper-argument__main {
        margin-top: 6px;
        width: 100%;
    }
}
</style>
